"use client";
import clsx from "clsx";

import useFilterModal from "@/lib/hooks/plpUseFilterModal";

const FilterButton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLButtonElement>) => {
  const { toggleModal } = useFilterModal();

  return (
    <button
      className={clsx("uppercase", "underline-hover", className)}
      onClick={(e) => {
        toggleModal();
        if (props.onClick) props.onClick(e);
      }}
      {...props}
    />
  );
};

export default FilterButton;
